import { useTranslation } from 'react-i18next';
import { Badge } from '@bliks-io/ui';

/** The "manuell erfasst" provenance mark (PRD 8.3). */
export function ManualCapacityBadge() {
  const { t } = useTranslation();

  return (
    <Badge variant="outline" colorScheme="blue" shape="pill" className="shrink-0 font-normal">
      {t('processes.capacityManualMark')}
    </Badge>
  );
}
